import { first } from "lodash";

export default class ModalFocusManager {
    constructor(modalElem) {
        this.modalElem = modalElem;
        this.listener = null;
    }

    _handleTrapEvent (lastFocusableElement, firstFocusableElement, event) {
        const isTabPressed = event.key === 'Tab' || event.keyCode === 9;

        if (!isTabPressed) {
            return;
        }

        if (event.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
                lastFocusableElement.focus();
                event.preventDefault();
            }
        }
        else if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            event.preventDefault();
        }
    }

    addModalFocusTrapHandler() {
        const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusableContent = this.modalElem.querySelectorAll(focusableElements);
        let firstFocusableElement;
        let lastFocusableElement;
        focusableContent.forEach((elem) => {
            if (!elem.disabled) {
                if (!firstFocusableElement) {
                    firstFocusableElement = elem;
                }

                lastFocusableElement = elem;
            }

        });

        if (!firstFocusableElement || !lastFocusableElement) {
            console.error(`ModalFocusManager.addModalFocusTrapHandler: Unable to locate focusable nodes in modalElem. First: ${!!firstFocusableElement} Last: ${!!lastFocusableElement}`);
            return null;
        }

        this.handler = this._handleTrapEvent.bind(this, lastFocusableElement, firstFocusableElement)
        document.addEventListener('keydown', this.handler);
    }

    removeModalFocusTrapHandler() {
        document.removeEventListener('keydown', this.handler);
    }

    refreshModalFocusTrapHandler() { // if disabled/focusable elements change
        document.removeEventListener('keydown', this.handler);
        this.addModalFocusTrapHandler();
    }
}